<template>
    <v-card 
        elevation="0" 
        class="option-abstract" 
        :class="{
            'option-abstract-selected': selected,
            'option-abstract-overmark': overmark,
            'option-abstract-disabled': !selectable,
            'option-abstract-loaded': isLoaded,
            'option-abstract-compact': compact
        }" 
        @click="handleClick" 
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave">
    
        <slot></slot>

        <!--<div v-if="selectable" class="option-abstract-mapping">{{ index }}</div>-->

    </v-card>
</template>

<script>
export default {
    name: 'OptionAbstract',
    props: {
        id: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        selected: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: true
        },
        compact: {
            type: Boolean,
            default: false
        },
        overmark: {
            type: Boolean,
            default: false
        }
    },
    emits: ['click', 'mouseenter', 'mouseleave'],
    data() {
        return {
            isLoaded: false
        }
    },
    mounted() {
        requestAnimationFrame(() => {
            this.isLoaded = true
        })
    },
    methods: {
        handleClick(event) {
            if (!this.selectable) return
            this.$emit('click')
        },
        handleMouseEnter(event) {
            if (!this.selectable) return
            this.$emit('mouseenter')
        },
        handleMouseLeave(event) {
            if (!this.selectable) return
            this.$emit('mouseleave')
        }
    }
}
</script>

<style scoped>
.option-abstract {
    position: relative;
    width: 600px;
    height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 2px solid rgb(var(--v-theme-lightbase));
    background-color: rgb(var(--v-theme-darkbase));
    overflow: hidden;
    user-select: none;
    opacity: 0;
    transition: opacity 0.3s ease, background-color 0.3s ease, border-color 0.3s ease;
}

.option-abstract-loaded {
    opacity: 1;
}

.option-abstract-mapping {
    position: absolute;
    top: 5px;
    right: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 8px;
    border: 1px solid rgb(var(--v-theme-shadow2));
    color: rgb(var(--v-theme-secondary));
}

.option-abstract:not(.option-abstract-disabled):hover {
    cursor: pointer;
    /*background-color: rgba(var(--v-theme-lightbase), 0.3);*/
    border-color: rgb(var(--v-theme-color1));
}

.option-abstract-overmark:not(.option-abstract-disabled):hover::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(var(--v-theme-lightbase), 0.3);
    z-index: 1;
    pointer-events: none;
}

.option-abstract-selected {
    border-color: rgb(var(--v-theme-color1));
    /*background-color: rgba(var(--v-theme-background), 0.3);*/
}

.option-abstract-selected .option-abstract-mapping {
    border: 1px solid rgb(var(--v-theme-secondary));
}

.option-abstract-overmark.option-abstract-selected::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(var(--v-theme-color1), 0.5);
    z-index: 1;
    pointer-events: none;
}

.option-abstract-disabled {
    cursor: default;
    /*background-color: rgba(var(--v-theme-darkbase), 0.5);*/
    color: rgb(var(--v-theme-secondary)) !important;
}

@media (max-width: 3000px) {
    .option-abstract {
        width: 500px;
        height: 500px;
    }
}

@media (max-width: 2500px) {
    .option-abstract {
        width: 420px;
        height: 420px;
    }
}

@media (max-width: 2000px) {
    .option-abstract {
        width: 380px;
        height: 380px;
    }
}

@media (max-width: 1800px) {
    .option-abstract {
        width: 340px;
        height: 340px;
    }
}

@media (max-width: 1500px) {
    .option-abstract {
        width: 280px;
        height: 280px;
    }
}

@media (max-width: 1200px) {
    .option-abstract {
        width: 260px;
        height: 260px;
    }
}

@media (max-width: 1000px) {
    .option-abstract {
        width: 230px;
        height: 230px;
    }

    .option-abstract-mapping {
        display: none;
    }
}

@media (max-width: 800px) {
    .option-abstract {
        width: 200px;
        height: 200px;
    }
}

@media (max-width: 600px) {
    .option-abstract {
        width: 160px;
        height: 160px;
    }
}

@media (max-width: 400px) {
    .option-abstract {
        width: 150px;
        height: 150px;
    }
}

.option-abstract.option-abstract-compact {
    width: 420px;
    height: 420px;
}

@media (max-width: 3000px) {
    .option-abstract.option-abstract-compact {
        width: 350px;
        height: 350px;
    }
}

@media (max-width: 2500px) {
    .option-abstract.option-abstract-compact {
        width: 294px;
        height: 294px;
    }
}

@media (max-width: 2000px) {
    .option-abstract.option-abstract-compact {
        width: 266px;
        height: 266px;
    }
}

@media (max-width: 1800px) {
    .option-abstract.option-abstract-compact {
        width: 238px;
        height: 238px;
    }
}

@media (max-width: 1500px) {
    .option-abstract.option-abstract-compact {
        width: 196px;
        height: 196px;
    }
}

@media (max-width: 1200px) {
    .option-abstract.option-abstract-compact {
        width: 182px;
        height: 182px;
    }
}

@media (max-width: 1000px) {
    .option-abstract.option-abstract-compact {
        width: 161px;
        height: 161px;
    }
}

@media (max-width: 800px) {
    .option-abstract.option-abstract-compact {
        width: 140px;
        height: 140px;
    }
}

@media (max-width: 600px) {
    .option-abstract.option-abstract-compact {
        width: 112px;
        height: 112px;
    }
}

@media (max-width: 400px) {
    .option-abstract.option-abstract-compact {
        width: 105px;
        height: 105px;
    }
}
</style>
